import { useQuery } from "@tanstack/react-query"
import { paths } from "../apiTypes"

export type VaultAssetsResponse =
  paths["/v2/vault/assets"]["post"]["responses"]["200"]["content"]["application/json"]

function getApiBase() {
  return process.env.NEXT_PUBLIC_EULER_API_URL ?? "http://localhost:42069"
}

export function useVaultAssets(
  chainId: string,
  {
    enabled = true,
    disabledPerspectives,
    enabledPerspectives,
    source = `${getApiBase()}/v2/vault/assets?chainId=${chainId}`,
  }: {
    enabled?: boolean
    disabledPerspectives?: string[]
    enabledPerspectives?: string[]
    source?: string
  } = {},
) {
  const url = source

  return useQuery<VaultAssetsResponse, Error>({
    queryKey: [
      "vaultAssets",
      chainId,
      disabledPerspectives,
      enabledPerspectives,
    ],
    queryFn: async () => {
      const response = await fetch(url, {
        method: "POST",
        headers: { "Content-Type": "application/json" },
        body: JSON.stringify({
          chainId,
          disabledPerspectives,
          enabledPerspectives,
        }),
      })
      if (!response.ok) {
        throw new Error(
          `Failed to fetch vault assets, status: ${response.status}`,
        )
      }
      return response.json()
    },
    enabled: enabled && !!chainId,
    refetchOnWindowFocus: false,
  })
}
